// Wireless presentation clickers (Logitech R400/Spotlight, Kensington, etc.) enumerate as USB
// keyboards. Models differ in what they send for "next slide" / "previous slide", so we accept the
// common variants. Space and Enter are deliberately excluded — they must keep activating whatever
// button currently has focus, and Enter already saves a goal in GoalTextInput.
export const PRESENTER_NEXT_KEYS = ['PageDown', 'ArrowRight', 'ArrowDown'];
export const PRESENTER_PREVIOUS_KEYS = ['PageUp', 'ArrowLeft', 'ArrowUp'];

export const PRESENTER_INTENT_NEXT = 'next';
export const PRESENTER_INTENT_PREVIOUS = 'previous';

const EDITABLE_TAG_NAMES = ['INPUT', 'TEXTAREA', 'SELECT'];

// The standup goal field is a contenteditable div (GoalTextInput.vue), not an input, so checking
// tag names alone is not enough — arrow keys there must move the caret, not the standup. The
// closest() check also covers nodes nested inside the editable region, and works where
// isContentEditable is unimplemented (jsdom).
export function isEditableElement(element) {
  if (!element || typeof element.closest !== 'function') return false;
  if (EDITABLE_TAG_NAMES.includes(element.tagName)) return true;
  if (element.isContentEditable === true) return true;

  return Boolean(element.closest('[contenteditable]:not([contenteditable="false"])'));
}

// The standup view is itself a Buefy modal, so one active modal is the normal state. A second one
// (the goal status explanation modal) means something is layered on top and keys should be inert.
function isNestedModalOpen() {
  if (typeof document === 'undefined') return false;

  return document.querySelectorAll('.modal.is-active').length > 1;
}

export function getPresenterKeyIntent(event) {
  if (!event) return null;
  // Leave browser and OS shortcuts (Cmd+ArrowLeft to go back, etc.) alone.
  if (event.metaKey || event.ctrlKey || event.altKey) return null;

  const activeElement = typeof document !== 'undefined' ? document.activeElement : null;
  if (isEditableElement(event.target) || isEditableElement(activeElement)) return null;

  if (isNestedModalOpen()) return null;

  if (PRESENTER_NEXT_KEYS.includes(event.key)) return PRESENTER_INTENT_NEXT;
  if (PRESENTER_PREVIOUS_KEYS.includes(event.key)) return PRESENTER_INTENT_PREVIOUS;

  return null;
}
